import {Link} from "react-router-dom"
import LineService from "../../../services/LineService";
import { Collapse,Card,Space,Empty ,Button} from "antd"
import { useState, useMemo, useEffect, useCallback } from "react";
import CenterService from "../../../services/CenterService";
import ReactHtmlParser from "react-html-parser";
import { useHistory, useLocation} from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Auth/userReducer';
const {Panel}=Collapse;


const RolesPermited=[
  "Coordinador del centro",
]

function callback(key) {
  console.log(key);
}

export default function CenterInformation(params){
  const [centerData,setCenterData]=useState([])
  const [centerDataLines,setCenterDataLines]=useState([])
  const {id:CenterID}=useParams()
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );
  const user= useSelector(selectUser)
  const [permissionComponents,setPermissionComponents]=useState(false)


  let listOptions=[{
    label:"Campo de acción del centro",
    key:"action",
    data: centerData?.action,
  },
  {
    label: "Objetivo del centro",
    key: "objetive",
    data: centerData?.objetive,
  }
  ]

  const getLinesByCenterId=useCallback(()=>{
    LineService.getLinesOwenByCenter(CenterID).then((res)=>{
      setCenterDataLines(res.data.response.rows);
    })
  },[])
  const getCenterDataByCenter=useCallback(()=>{
    CenterService.getCenterDataByCenter(CenterID).then((res)=>{
      console.log(res.data)
      setCenterData(res.data.response);
    })
  },[])

  const verificityPermissionRol=()=>{
        console.log("user.rolName",user.rolName)
        return RolesPermited.includes(user.rolName)
    }
    
  useEffect(()=>{
    //setCenterData(params.body.CenterDatum);
    getCenterDataByCenter();
    getLinesByCenterId();
    if (searchParams.get('option')!=="dataMisionAndVision") {
      searchParams.set('option', 'dataMisionAndVision');
      history.replace({ search: searchParams.toString() });
    }
    setPermissionComponents(verificityPermissionRol()) 
  },[])
  
  return (
    <>
    {permissionComponents && (<Card>
      <Space>
        {centerData==null &&(<Link 
        style={{display:"flex", flexDirection:"column"}} 
        to={{pathname:"/center/detail/"+params?.body?.id+"/objetives/create",state:{centerData:centerData,list:listOptions}}}
        >
          <Button 
          key={"createBtn"}
          >
            Añadir información
          </Button>
        </Link >)}  
        {centerData!=null &&(<Link 
        style={{display:"flex", flexDirection:"column"}} 
        to={{pathname:"/center/detail/"+params?.body?.id+"/objetives/update",state:{centerData:centerData,list:listOptions}}}
        >
          <Button
          key={"updateBtn"}>
            Editar informacion
          </Button>
        </Link>)}
      </Space>
    </Card>)}
    <Card>
      {centerData ? (<Collapse onChange={callback}>
        <Panel header="Campo de acción del centro" key="1">
          <p>{ReactHtmlParser(centerData.action)}</p>
        </Panel>
        <Panel header="Objetivo del centro" key="2">
          <p>{ReactHtmlParser(centerData.objetive)}</p>
        </Panel>
        <Panel header="Líneas de investigación del Centro" key="3">
          <ul style={{padding:20}}>
          {centerDataLines.map((res)=>{
            return <li>{res.name}</li>
          })}
          </ul>
        </Panel>
      </Collapse>): <Empty/>}
    </Card>
    </>
  )
} 